import React, { forwardRef, ReactNode, ChangeEventHandler } from "react";
import { Checkbox } from "@mui/material";

interface TableProps extends React.HTMLAttributes<HTMLTableElement> {
  tableHead: { name: string }[];
  handleSelectAllClick?: ChangeEventHandler<HTMLInputElement>;
  checkbox?: boolean;
  textIndex: number;
  children: ReactNode;
}

const Table = forwardRef<HTMLTableElement, TableProps>(
  ({ tableHead, handleSelectAllClick, checkbox, textIndex, children, ...props }, ref) => {
    return (
      <div className="relative overflow-x-auto">
        <table
          className="table-auto text-black bg-white mt-7 rounded-xl"
          style={{ boxShadow: "0px 10px 60px 0px #E2ECF980", minWidth: "800px", width: "100%" }}
          ref={ref}
          {...props}
        >
          <thead>
            <tr>
              {checkbox && (
                <th className="border-b border-[#EAECF0]">
                  <Checkbox onChange={handleSelectAllClick} />
                </th>
              )}
              {tableHead.map((val, index) => {
                const thClasses = `p-5 text-base text-[#71717A] border-b border-[#EAECF0] font-medium uppercase ${
                  index > textIndex ? "text-center" : "text-left"
                }`;
                return (
                  <th key={index} className={thClasses}>
                    {val.name}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>{children}</tbody>
        </table>
      </div>
    );
  }
);

Table.displayName = "Table";

export default Table;
